import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/orders/$orderId/attribution")({
  head: () => ({
    meta: [{ title: "订单归因 · imiker CRM" }],
  })
});
